export default __webpack_public_path__ + "ff7cda76b6e65c49e7252b193ba9ed84.png";